module.exports = __webpack_public_path__ + "static/get-involved-left-bg.4298a1d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/profiles/get-involved-left-bg.svg
// module id = 3731
// module chunks = 168707334958949